import React from "react";
import classes from "./Button.module.css";
const Button = (props) => {
  const className = `${classes.button} ${props.className}`
  return (
    <button onClick={props.onClick} type="submit" className={className} disabled={props.disabled} id={props.id||"btn"}>
      {props.children}
    </button>
  );
};

export default Button;
